export const prod = {
  name: 'prod',
  production: true,
  domain: 'https://www.thermofisher.com',
  services: {
    cloudReferrer: "https://apps.thermofisher.com/apps/dashboard/#/",
    cdcam: {
      reset_password: {
        request_email: 'https://www.thermofisher.com/api-gateway/identity/reset-password/email',
        request: 'https://www.thermofisher.com/api-gateway/identity/reset-password/'
      },
      recover_username: 'https://www.thermofisher.com/api-gateway/accounts/username/recovery',
      identity: {
        login: 'https://www.thermofisher.com/api-gateway/identity/registration/redirect/login',
        registration: 'https://www.thermofisher.com/identity/account/registration',
        federation: {
          enabled: true,
          find_federated: '/api-gateway/identity-authorization/identity/fed/findfederateduser'
        },
        liteRegCheck: "/identity/api/cip/v1/literegistered/",
        rpUrls:"/api-gateway/identity-authorization/identity/auth-services/rp/urls/"
      },
    }
  },
  adobe: {
    digitalData: '/etc/designs/lifetech/clientlibs/digitaldata.min.js',
    enabled: true,
    launch: 'ENeecb77f1160a4928a492ff040f7110c7'
  },
  pages: {
    loginError: "/account-center/loginError.html?source=gigyajs-proxy",
    contact_us: '/us/en/home/technical-resources/contact-us.html',
    privacy_policy: '/us/en/home/global/privacy-policy.html',
    policy_freight: '/us/en/home/global/online-pricing-policy.html',
    terms_condition: '/us/en/home/global/terms-and-conditions.html',
    china: {
      contact_us_cn: '/cn/zh/home/hotline-guideline.html',
      business_check: 'https://218.242.124.22:8082/businessCheck/verifKey.do?showType=extShow&serial=9031000020171215105412000002252469-SAIC_SHOW_310000-4028e4cb6493ac2c0164c34158830f04018&signData=MEUCIGaAKW51heNd3cUsvTfF7YfkQoSdAyn4cx1XhwWh1t7BAiEAj22lrLm+yIbfvVqeOKnPa+Pz7/e6ouAI9EC1cJRPHRs=',
      icp_registration_number: 'https://beian.miit.gov.cn/',
      license: '/cn/zh/home/global/licenses-cn.html'
    }
  },
  resources: {
    reCaptchaV3: {
      siteKey: '6LfLnt8ZAAAAAJJXiCIGn9OLaxs1EiGUK1ZOlMZV'
    },
    reCaptchaV2: {
      siteKey: '6LebEM0ZAAAAAD4lgIFl61uQnh43Td2EYce_P_rt'
    }
  },
  shared_static: {
    global: '/shared-static/scripts/global-variables.js'
  }
};
